import React, { FC } from 'react';
import { InfoNotification, P, TextLink } from '@ovotech/element-v5';
import { KWIK_FIT_CLUB_MAINTENANCE_LINK } from '@monovo/ev-anytime';
import { CHARGE_ANYTIME_KWIK_FIT_MAINTENANCE } from '@/src/constants/feature-flags';
import { useFeature } from '@/src/utils/optimizely';

const TITLE = 'Kwik Fit Club is under maintenance';
const BODY =
  "New memberships are temporarily paused. It'll be back soon, and your other benefits aren't affected in the meantime.";

/**
 * Tells customers the Kwik Fit Club perk (bundled with the 1000+ mile monthly
 * plans) isn't taking new memberships. Renders nothing unless the
 * `charge_anytime_kwik_fit_maintenance` flag is on, so it can be switched off
 * the moment the perk is back without a release.
 */
export const KwikFitMaintenanceNotification: FC = () => {
  const [isKwikFitUnderMaintenance] = useFeature(
    CHARGE_ANYTIME_KWIK_FIT_MAINTENANCE,
  );

  if (!isKwikFitUnderMaintenance) {
    return null;
  }

  return (
    <InfoNotification
      id="kwik-fit-maintenance"
      title={TITLE}
      data-testid="kwik-fit-maintenance-notification"
    >
      <P>{BODY}</P>
      <TextLink opensInNewWindow href={KWIK_FIT_CLUB_MAINTENANCE_LINK}>
        Find out more
      </TextLink>
    </InfoNotification>
  );
};
